// extracted by mini-css-extract-plugin
module.exports = {"alert":"doiSuccessAlert___alert___30Pme","icon":"doiSuccessAlert___icon___1kopy"};